var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.889 11.42c4.54 0 4.546 6.87 0 6.87-4.54 0-4.546-6.87 0-6.87z",
    fill: "url(#instagram_svg__paint0_linear_8793_23601)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.889 11.42c4.54 0 4.546 6.87 0 6.87-4.54 0-4.546-6.87 0-6.87z",
    fill: "url(#instagram_svg__paint1_linear_8793_23601)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.622 6.397c-.52.005-1.071.01-1.657.011v-.002c-6.869.007-7.52.137-7.52 8.444 0 8.212.236 8.447 8.445 8.447.414 0 .821.005 1.219.009 3.927.043 6.965.076 7.165-4.291.577-12.695-.361-12.687-7.652-12.618zm3.53 2.957a1.236 1.236 0 112.472 0 1.236 1.236 0 01-2.472 0zm-9.554 5.5a5.29 5.29 0 1110.58 0 5.289 5.289 0 11-10.58 0z",
    fill: "url(#instagram_svg__paint2_linear_8793_23601)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.622 6.397c-.52.005-1.071.01-1.657.011v-.002c-6.869.007-7.52.137-7.52 8.444 0 8.212.236 8.447 8.445 8.447.414 0 .821.005 1.219.009 3.927.043 6.965.076 7.165-4.291.577-12.695-.361-12.687-7.652-12.618zm3.53 2.957a1.236 1.236 0 112.472 0 1.236 1.236 0 01-2.472 0zm-9.554 5.5a5.29 5.29 0 1110.58 0 5.289 5.289 0 11-10.58 0z",
    fill: "url(#instagram_svg__paint3_linear_8793_23601)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.917 11.68C.863 6.726.841 4.713 2.683 2.8 4.616.796 6.727.814 14.12.875c1.53.013 3.288.028 5.317.027 3.273.005 3.459.032 4.08.122l.035.006c2.835.408 4.988 2.423 5.262 5.919.037.467.037 15.339.001 15.797-.258 3.282-2.146 5.165-4.467 5.763-1.738.45-17.16.45-18.9.003C.656 27.273.77 22.577.898 17.405c.02-.844.04-1.7.04-2.557 0-1.176-.01-2.226-.021-3.169zM13.87 4.545c.337.003.676.005 1.016.005.405 0 .797-.002 1.176-.005 3.291-.022 5.623-.038 7.395 1.734 1.766 1.764 1.753 4.058 1.735 7.457a199.069 199.069 0 00-.002 2.149c.01 2.483.016 4.27-.543 5.717-1.414 3.628-5.008 3.595-8.698 3.562-.354-.003-.709-.007-1.063-.007-.339 0-.677.003-1.013.005-3.815.028-7.342.054-8.746-3.56-.558-1.437-.55-3.573-.543-5.898l.002-.85-.002-1.018c-.01-2.485-.016-4.297.543-5.731 1.407-3.613 4.908-3.587 8.743-3.56z",
    fill: "url(#instagram_svg__paint4_linear_8793_23601)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.917 11.68C.863 6.726.841 4.713 2.683 2.8 4.616.796 6.727.814 14.12.875c1.53.013 3.288.028 5.317.027 3.273.005 3.459.032 4.08.122l.035.006c2.835.408 4.988 2.423 5.262 5.919.037.467.037 15.339.001 15.797-.258 3.282-2.146 5.165-4.467 5.763-1.738.45-17.16.45-18.9.003C.656 27.273.77 22.577.898 17.405c.02-.844.04-1.7.04-2.557 0-1.176-.01-2.226-.021-3.169zM13.87 4.545c.337.003.676.005 1.016.005.405 0 .797-.002 1.176-.005 3.291-.022 5.623-.038 7.395 1.734 1.766 1.764 1.753 4.058 1.735 7.457a199.069 199.069 0 00-.002 2.149c.01 2.483.016 4.27-.543 5.717-1.414 3.628-5.008 3.595-8.698 3.562-.354-.003-.709-.007-1.063-.007-.339 0-.677.003-1.013.005-3.815.028-7.342.054-8.746-3.56-.558-1.437-.55-3.573-.543-5.898l.002-.85-.002-1.018c-.01-2.485-.016-4.297.543-5.731 1.407-3.613 4.908-3.587 8.743-3.56z",
    fill: "url(#instagram_svg__paint5_linear_8793_23601)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__paint0_linear_8793_23601",
    x1: 29.4,
    y1: 1.114,
    x2: 1.115,
    y2: 29.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__paint1_linear_8793_23601",
    x1: 2.736,
    y1: 27.023,
    x2: 28.67,
    y2: 4.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__paint2_linear_8793_23601",
    x1: 29.4,
    y1: 1.114,
    x2: 1.115,
    y2: 29.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__paint3_linear_8793_23601",
    x1: 2.736,
    y1: 27.023,
    x2: 28.67,
    y2: 4.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__paint4_linear_8793_23601",
    x1: 29.4,
    y1: 1.114,
    x2: 1.115,
    y2: 29.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__paint5_linear_8793_23601",
    x1: 2.736,
    y1: 27.023,
    x2: 28.67,
    y2: 4.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })))));
}

export default __webpack_public_path__ + "./fonts/instagram.b2ad472e56a8fac26962efe5ed7af7b4.svg";
export { SvgInstagram as ReactComponent };